// extracted by mini-css-extract-plugin
module.exports = {"hotspot-map":"hotspot-map_hotspot-map__2PCVU","nav":"hotspot-map_nav__3knVN","completed":"hotspot-map_completed__3kuFA","map":"hotspot-map_map__1PfvU"};